import React from "react";
import { Link } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import ConfigurationBarWrapper from "./ConfigurationBarWrapper";

export const Wrapper = styled.section`
  .linkPlay {
    position: relative;
  }
  .play {
    font-size: 12px;
    top: 4px;
    position: absolute;
  }
  .backward {
    margin-right: 10px;
  }
  .home-settings {
    /* config buttons */
    button {
      padding: 6px 12px;
      border: 1px solid #333;
      &:first-of-type {
        margin-right: 4px;
      }
    }
  }
  .setting-text {
    font-size: 13px;
    line-height: 14px;
    margin-top: 4px;
    label {
      &:hover {
        cursor: pointer;
      }
    }
  }
  .home-settings-open {
    position: absolute;
    right: 0;
    z-index: 1;
    border: 1px solid #666;
    background-color: #ccc;
    padding: 15px 16px 0px 10px;
  }
`;

function HomeHeader(props) {
  const { date, daysAgo, settings } = props;
  const next = parseInt(daysAgo, 10) - 1;
  const prev = parseInt(daysAgo, 10) + 1;

  return (
    <Wrapper>
      <Row noGutters>
        <Col xs={8} md={9}>
          {daysAgo === 0 && (
            <div className="home-header">
              <h2>Today's Tracks</h2>
            </div>
          )}
          {daysAgo !== 0 && (
            <div className="home-header">
              <h2>Tracks Rewind</h2>
              <div>{date}</div>
              {prev > 0 && (
                <span>
                  <Link to={`/rewind/${prev}`}>
                    <FontAwesomeIcon title="Back a day" icon="backward" className="backward" />
                  </Link>
                </span>
              )}
              {next == 0 && (
                <span>
                  <Link to={`/`} className="linkPlay">
                    <FontAwesomeIcon title="Today" icon="play" className="play" />
                  </Link>
                </span>
              )}
              {next > 0 && (
                <span>
                  <Link to={`/rewind/${next}`}>
                    <FontAwesomeIcon title="Forward a day" icon="forward" className="forward" />
                  </Link>
                </span>
              )}
            </div>
          )}
        </Col>
        <Col xs={4} sm={4} md={3} className="home-settings text-right">
          <ConfigurationBarWrapper {...props} />
        </Col>
      </Row>
    </Wrapper>
  );
}

export default HomeHeader;
